import { render, staticRenderFns } from "./WellCome.vue?vue&type=template&id=bb619230&"
import script from "./WellCome.vue?vue&type=script&lang=js&"
export * from "./WellCome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports